import { createContext } from 'react';
import { AppContextValue } from '../type';

export const appContextInitialValue: AppContextValue = {
  setState: () => {},
  state: {},
};

export const AppContext = createContext(appContextInitialValue);
